import { Box, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { useState } from 'react';

interface VSelectMonitoringFrequencyProps {
    initFrequency?: string;
    onTypeChange?: (newFrequency: string) => void;
    error?: boolean
    activeLabel?: boolean
    required?: boolean
}

export const VSelectMonitoringFrequency = ({initFrequency = '', onTypeChange, error = false, activeLabel = true, required, }: VSelectMonitoringFrequencyProps) => {

    const [ type, setType ] = useState(initFrequency);

    const handleChange = (event: SelectChangeEvent) => {
        const newFrequency = event.target.value as string;
        setType(newFrequency);
        if (onTypeChange) {
            onTypeChange(newFrequency);
        }
    };

    const textTitle = required ? 'Unidade de Medida da Frequência de monitoramento *' : 'Unidade de Medida da Frequência de monitoramento';

    return(
        <Box width={'100%'}>
            <FormControl fullWidth>
                <InputLabel id='freq_monit_medida'>{activeLabel? textTitle : ''}</InputLabel>
                <Select
                    labelId='freq_monit_medida'
                    label={activeLabel? 'Unidade de Medida da Frequência de monitoramento' : ''}
                    value={type}
                    onChange={handleChange}
                    error={error}
                >
                    <MenuItem value={'Meses'} >Meses</MenuItem>
                    <MenuItem value={'Dias'} >Dias</MenuItem>
                    <MenuItem value={'Horas'} >Horas</MenuItem>
                    <MenuItem value={'Minutos'} >Minutos</MenuItem>
                    <MenuItem value={'Segundos'} >Segundos</MenuItem>
                </Select>
            </FormControl>
        </Box>
    );
};